/**
 * @format
 */

import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { Advertisement, FullCategory } from '../../api/adserver';
import Carousel, { DisplayType } from '../../components/Carousel';
import config from '../../lib/config';

export interface Props {
  item: FullCategory;
  onPress?: (item: Advertisement) => void;
  onPressCategory?: (item: FullCategory) => void;
}

const CategoryListItem: React.FC<Props> = (props) => {
  const { item, onPressCategory, onPress } = props;
  try {
    const items = (item && item.adverts && item.adverts.slice(0, 4)) || [];
    const headerStyle = [];
    if (Platform.OS !== 'web') {
      headerStyle.push(styles.featureHeadingContainer);
    }
    headerStyle.push(styles.sectionStart);
    return (
      <>
        <View style={headerStyle}>
          <Text style={styles.featureHeading}>{item.title}</Text>
        </View>
        <Carousel
          name={`caregoryadverts-${item.id}`}
          displayType={DisplayType.adverts}
          items={items}
          onPress={onPress}
          onViewMore={() => {
            if (onPressCategory) {
              onPressCategory(item);
            }
          }}
          showViewMore
        />
      </>
    );
  } catch (e) {
    console.log('slice error for item', item, item.adverts);
  }
  return null;
};

const styles = StyleSheet.create({
  scrollView: {
    backgroundColor: '#ffffff',
    marginHorizontal: 10,
  },
  engine: {
    position: 'absolute',
    right: 0,
  },
  featureHeadingContainer: {
    flex: 1,
    flexDirection: 'row',
    marginBottom: 0,
    justifyContent: 'space-between',
    marginStart: 5,
    marginEnd: config.theme.headingEndMargin,
  },
  sectionStart: {
    marginTop: 23,
    marginBottom: 0,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
  },
  featureViewAll: {
    fontSize: 14,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: config.theme.headingTextColor,
  },
});

export default CategoryListItem;
